function clipVariantSelectorLabels() {
  const labels = document.querySelectorAll('.swatch-element label');

  if (window.innerWidth <= 1400) {
    labels.forEach(function (label) {
      const originalText = label.getAttribute('data-original-text') || label.textContent.trim();

      // Exclude labels that contain "trio"
      if (originalText.toLowerCase().includes("3")) {
        return;
      }

      label.setAttribute('data-original-text', originalText);

      let clippedText = originalText;

      clippedText = clippedText.replace(/\s*\(.*?\)\s*/g, '').trim();

      label.textContent = clippedText;
    });
  } else {
    labels.forEach(function (label) {
      const originalText = label.getAttribute('data-original-text');
      if (originalText) {
        label.textContent = originalText;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", clipVariantSelectorLabels);
window.addEventListener("resize", clipVariantSelectorLabels);

document.querySelectorAll('.swatch-element input[type="radio"]').forEach(function (input) {
  input.addEventListener('change', function(event) {
    const variantId = event.target.getAttribute('data-variant');
    const variantImg = event.target.getAttribute('data-image');
    const productHandle = event.target.closest('.shop-all-grid-item').getAttribute('data-product-handle');

    console.log('Swatch selected for product handle:', productHandle, 'Variant ID:', variantId);
    
    updateProductCard(productHandle, variantId, variantImg, event.target.closest('.shop-all-grid-item'));
  });
});

function updateProductCard(productHandle, variantId, variantImg, productCardElement) {
  console.log('Fetching product data for:', productHandle);
  
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(productData => {
      console.log('Product data received:', productData);
      
      const variant = productData.variants.find(v => v.id == variantId);
      if (variant) {
        console.log('Variant data found:', variant);
        
        const priceElement = productCardElement.querySelector('[data-product-price]');
        if (priceElement) {
          priceElement.innerText = `| ${Shopify.formatMoney(variant.price).replace('.00', '')}`;
        }
        
        if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
          const variantImageSrc = variant.featured_media.preview_image.src;
          const productImageElement = productCardElement.querySelector('.prod-image');
        
          if (productImageElement) {
            productImageElement.src = variantImageSrc;
            productImageElement.srcset = `
              ${variantImageSrc.replace('.jpg', '_150x.jpg')} 480w,
              ${variantImageSrc.replace('.jpg', '_300x.jpg')} 768w,
              ${variantImageSrc.replace('.jpg', '_600x.jpg')} 1024w
            `;
            console.log('Updated product image:', variantImageSrc);
          } else {
            console.error('Product image element not found.');
          }
        } else {
          console.error('Variant image not found for ID:', variantId);
        }

        const sellingPlanGroupId = variant.selling_plan_allocations[0]?.selling_plan_group_id;
        const sellingPlanGroup = productData.selling_plan_groups.find(group => group.id == sellingPlanGroupId);

        if (sellingPlanGroup) {
          const sellingPlanSelect = productCardElement.querySelector('.subscription-product-form-select select');
          if (sellingPlanSelect) {
            sellingPlanSelect.innerHTML = '';

            sellingPlanGroup.selling_plans.forEach(plan => {
              const option = document.createElement('option');
              option.value = plan.id;
              option.textContent = plan.name;
              sellingPlanSelect.appendChild(option);
            });

            console.log('Updated selling plan options:', sellingPlanGroup.selling_plans);
          }
        } else {
          console.warn('No matching selling plan group found for group ID:', sellingPlanGroupId);
        }

        const variantIdInput = productCardElement.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = variant.id;
          console.log('Updated hidden input with new variant ID:', variant.id);
        } else {
          console.error('Hidden input for variant ID not found in the product card.');
        }

        const variantAddButton = productCardElement.querySelector('.variant-add');
        if (variantAddButton) {
          variantAddButton.setAttribute('data-product-id', variant.id);
          console.log('Updated variant-add button with new variant ID:', variant.id);
        } else {
          console.error('Variant-add button not found in the product card.');
        }
        
        console.log('Product card updated with new variant:', variant);
      } else {
        console.error('Variant not found for ID:', variantId);
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
}

document.querySelectorAll('.variant-add').forEach(function (button) {
    button.addEventListener('click', function(event) {
        event.preventDefault();
        const productId = button.getAttribute('data-product-id');
        console.log('Adding product with variant ID:', productId);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            enableLoading();
            cartDrawer.show();
            const cartDrawerEmpty = cartDrawer.querySelector('.cart-drawer-empty-msg');
            if (cartDrawerEmpty) {
                cartDrawerEmpty.classList.add('hidden-el');
            }
        }

        Shopify.addItem(productId, 1, function(cart) {
            console.log('Item added to cart:', cart);
            const event = new CustomEvent('addtocart');
            document.dispatchEvent(event);
        });
    });
});